import { h } from "preact";
const PreactCollapse = (props) => {
    var _a;
    return (h("button", { class: `${(_a = props.class) !== null && _a !== void 0 ? _a : ""} collapsed`, type: "button", "data-bs-toggle": "collapse", "data-bs-target": props.target },
        h("span", { class: "icon-caret-up collapsed__hide" }),
        h("span", { class: "icon-caret-down collapsed__show" })));
};
export default PreactCollapse;
